import React from 'react';
import {Field} from 'formik';

import styles from 'legacy_css_modules/ItemCell.module.css';
import { memo } from "react";

//export const ItemCell
const MemoItemCell = ({children, className, disabled, inputClass, isHidden, isRequired, ...props}) => {
    
    if (props.type === 'checkbox'){
        return (
            <label className={styles.itemcell}>{children}
                <Field className={styles.formikcheckbox} disabled={disabled} {...props}/>
            </label>
        )
    }
    else if (props.type === 'autocompleteselect'){
        
        return (
            <label >{children}
                <Field  disabled={disabled} {...props}/>
            </label>
        )
    }
    else {
        return (
            <label className={styles.itemcell}>{children}
                <Field className={styles.formikcell} disabled={disabled} {...props}/>
            </label>
        )
    }

    
};


export const ItemCell = memo(MemoItemCell)